/*
 * Royal Gifts — shared Diwali countdown + coupon copy.
 *
 * Every [data-rg-countdown] element is driven by ONE timer and computed from the same
 * activation timestamp (data-rg-countdown-start, set in snippets/diwali-countdown-timer.liquid),
 * so all timers on the page — and all visitors — show the same value.
 *
 * Rolling rule: the countdown runs from 10 days down; once 3 hours or less remain it
 * immediately restarts at 10 days. That makes each cycle 10d - 3h = 237h long, so the
 * deadline is derived deterministically: no storage, no per-visitor deadline, and
 * refreshes/navigation never reset it.
 */
(function () {
  'use strict';

  if (window.RGDiwaliCountdown) {
    window.RGDiwaliCountdown.refresh();
    return;
  }

  var SECOND = 1000;
  var HOUR = 60 * 60 * SECOND;
  var DAY = 24 * HOUR;
  var DURATION = 10 * DAY;
  var RESET_THRESHOLD = 3 * HOUR;
  var CYCLE = DURATION - RESET_THRESHOLD;
  var FALLBACK_START = Date.UTC(2026, 9, 11, 18, 30, 0); // 2026-10-12 00:00 IST

  var timeoutId = null;

  function getStart(el) {
    var seconds = parseInt(el.getAttribute('data-rg-countdown-start'), 10);
    return isFinite(seconds) && seconds > 0 ? seconds * SECOND : FALLBACK_START;
  }

  // Remaining ms in the current cycle, always within (RESET_THRESHOLD, DURATION].
  function getRemaining(start, now) {
    var elapsed = (((now - start) % CYCLE) + CYCLE) % CYCLE;
    return DURATION - elapsed;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function render() {
    var timers = document.querySelectorAll('[data-rg-countdown]');
    if (!timers.length) return false;

    var now = Date.now();
    for (var i = 0; i < timers.length; i++) {
      var el = timers[i];
      var totalSeconds = Math.floor(getRemaining(getStart(el), now) / SECOND);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      setText(el.querySelector('[data-rg-countdown-days]'), pad(days));
      setText(el.querySelector('[data-rg-countdown-hours]'), pad(hours));
      setText(el.querySelector('[data-rg-countdown-minutes]'), pad(minutes));
      setText(el.querySelector('[data-rg-countdown-seconds]'), pad(seconds));

      var label = 'Offer ends in ' + days + ' days ' + hours + ' hours ' + minutes + ' minutes';
      if (el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
    }
    return true;
  }

  // Single self-correcting loop aligned to the next whole second (no drift, no duplicates).
  function schedule() {
    clearTimeout(timeoutId);
    timeoutId = null;
    if (!render()) return;
    timeoutId = setTimeout(schedule, SECOND - (Date.now() % SECOND) + 5);
  }

  /* ---------- Coupon copy ---------- */

  function fallbackCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {
      ok = false;
    }
    document.body.removeChild(textarea);
    return ok;
  }

  function showCopied(button, ok) {
    var label = button.querySelector('[data-rg-copy-label]');
    button.classList.toggle('is-copied', ok);
    if (label) {
      if (!label.hasAttribute('data-default-text')) label.setAttribute('data-default-text', label.textContent);
      label.textContent = ok ? 'Copied!' : label.getAttribute('data-default-text');
    }
    clearTimeout(button._rgCopyTimer);
    button._rgCopyTimer = setTimeout(function () {
      button.classList.remove('is-copied');
      if (label) label.textContent = label.getAttribute('data-default-text');
    }, 2000);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-rg-copy-code]');
    if (!button) return;
    event.preventDefault();
    var code = button.getAttribute('data-rg-copy-code');
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(
        function () { showCopied(button, true); },
        function () { showCopied(button, fallbackCopy(code)); }
      );
    } else {
      showCopied(button, fallbackCopy(code));
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) schedule();
  });
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', schedule);

  window.RGDiwaliCountdown = { refresh: schedule, getRemaining: getRemaining };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
